import axios from "axios";
import { Config } from "../../../core/config/config";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/integration-management/executions`;

export const integrationManagementService = {
    startJob: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/start`, params)
            .then((response) => {                
                return response;
            });
    }       
}